class ValidationsService {
    validatePassword(pass) {
        const result = {
            isValid: false,
            message: 'Password length must be more than 6'
        };
        if (pass && pass.length > 6) {
            result.isValid = true;
        }

        return result;
    }

    validateUrl(url) {
        try {
            const parsed = new URL(url.trim());
            return (parsed.protocol === 'http:' || parsed.protocol === 'https:') && Boolean(parsed.hostname);
        } catch (error) {
            return false;
        }
    }

    validateIp(ip) {
        const host = ip.trim();
        const ipv4 = host.match(
            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/);
        if (ipv4) {
            return true;
        }

        if (host.includes(':')) {
            try {
                new URL(`http://[${ host }]/`);
                return true;
            } catch (error) {
                return false;
            }
        }

        if (!host || host.length > 253 || (/^[0-9.]+$/.test(host) && host.includes('.'))) {
            return false;
        }
        return host.replace(/\.$/, '').split('.').every(label => (
            label.length > 0 &&
            label.length <= 63 &&
            /^[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/.test(label)
        ));
    }

    validateHttpStatus(status) {
        return Number.isInteger(status) && (status === 0 || (status >= 100 && status <= 599));
    }
}

const validationService = new ValidationsService();
export default validationService;
